import React, { createContext, useContext, useReducer } from 'react';
import { IinitialState } from '../models/vertex-search-page-models';

export const VertexSearchContext = createContext(null);
export const VertexSearchDispatchContext = createContext(null);

interface providerState {
    initialState: IinitialState,
    children?: React.ReactNode
}

interface providerActions {
    type: string,
    data?: any
}

export function VertexSearchProvider({ initialState, children }: providerState) {
    const [state, dispatch] = useReducer(
        stateReducer,
        initialState
    );

    return (
        <VertexSearchContext.Provider value={state}>
            <VertexSearchDispatchContext.Provider value={dispatch}>
                {children}
            </VertexSearchDispatchContext.Provider >
        </VertexSearchContext.Provider>

    );
}

export function useVertexSearchContext() {
    return useContext(VertexSearchContext);
}

export function useVertexSearchDispatch() {
    return useContext(VertexSearchDispatchContext);
}

function stateReducer(state: IinitialState, action: providerActions) {
    switch (action.type) {
        case 'updateCurrentSearchContext': {
            return {
                ...state,
                currentSearchContext: action.data
            }
        }
        case 'updateSearchResults': {
            return {
                ...state,
                searchResultsContainer: action.data
            }
        }
        case 'updateCurrentSearchQuery': {
            return {
                ...state,
                currentSearchQuery: action.data
            }
        }
        case 'updateSelectedShopFilters': {
            return {
                ...state,
                selectedShopFilters: action.data
            }
        }
        case 'updateSelectedShopFiltersString': {
            return {
                ...state,
                selectedShopFiltersString: action.data
            }
        }
        case 'updateFacetsShowMoreState': {
            return {
                ...state,
                facetsShowMoreState: action.data
            }
        } 
        case 'updateFacetsAccordionClosedState': {
            return {
                ...state,
                facetsAccordionClosedState: action.data
            }
        }
        default: {
            return state;
        }
    }
}